// The care meeting's pure derivations, kept out of the JSX.
//
// TES-955 — the meeting's own header and fact column are gone (the patient
// page's header is on top), and with them the age, BMI and lab-track helpers
// that only they used.

/** mm:ss (or h:mm:ss past the hour) for the meeting timer. */
export function formatElapsed(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(sec).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
